// extracted by mini-css-extract-plugin
export var actions = "_2-5";
export var content = "_2-3";
export var frame = "_2-1";
export var pickerGrid = "_2-4";
export var shell = "_2-0";
export var viewport = "_2-2";